import { Button, Tooltip } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export interface ViewButtonProps {
  onClick: () => void;
}

export const ViewButton = (props: ViewButtonProps) => {
  const { onClick } = props;
  const { t } = useTranslation(['common']);

  return (
    <Tooltip
      label={t('buttons.view', {
        ns: 'common',
        defaultValue: 'View',
      })}
    >
      <Button variant="subtle" size="xs" onClick={onClick}>
        <IconEye size={14} />
      </Button>
    </Tooltip>
  );
};
